export const CHECKLIST_DATA = 'CHECKLIST_DATA'
export const CHECKLIST_LISTING = 'CHECKLIST_LISTING'
export const CHECKLISTITEM_DATA = 'CHECKLISTITEM_DATA'
export const CHECKLIST_FILTER = 'CHECKLIST_FILTER'
export const CHECKLIST_ITEM_DETAIL = 'CHECKLIST_ITEM_DETAIL'
